import DetailsDeployment from './DetailsDeployment';

export default DetailsDeployment;
